import { PanelLeftClose, PanelLeftOpen, StepBack } from "lucide-react";
import { getSupportDisplayPicUrl } from "../../../utilities/conversions";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

export default function SidebarModule({ tab, setTab, mobileMenu, setMobileMenu, profile, baseUrl, onLogout, sidebarCollapsed, setSidebarCollapsed }: { tab: string, setTab: (tab: string) => void, mobileMenu: boolean, setMobileMenu: (menu: boolean) => void, profile: any, baseUrl: string, onLogout: () => void, sidebarCollapsed: boolean, setSidebarCollapsed: (collapsed: boolean) => void }) {
    const [cmsOpen, setCmsOpen] = useState(tab === "CMS" || tab === "Blogs" || tab === "Blog detail" ? true : false);
    return (
        <>
            <div className="md:hidden h-14 bg-white border-b border-slate-200 flex items-center justify-between px-4">
                <p className="font-semibold">Dashboard</p>
                <button
                    onClick={() => setMobileMenu(!mobileMenu)}
                    className="w-9 h-9 rounded-full bg-slate-200 overflow-hidden"
                    aria-label="Åpne/lukke meny"
                >
                    <img
                        src={getSupportDisplayPicUrl(profile?.profile_pic, baseUrl)}
                        alt={profile?.name}
                        className="w-full h-full object-cover"
                    />
                </button>
            </div>
            <aside
                className={`bg-white border-r border-slate-200 flex flex-col fixed md:relative inset-y-0 left-0 z-40
                            transition-all duration-300
                            ${mobileMenu ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
                            ${sidebarCollapsed ? "md:w-16" : "md:w-72"}
                        `}
            >
                <div className="h-16 px-6 flex items-center border-b border-slate-200">
                    {!sidebarCollapsed && (
                        <>
                            <div className="w-9 h-9 rounded-2xl bg-gradient-to-tr from-indigo-500 to-violet-500 mr-3" />
                            <div>
                                <p className="text-xs uppercase tracking-wide text-slate-400">Chamcore Client</p>
                                <p className="font-semibold">Teletorget AS</p>
                            </div>
                        </>
                    )}
                    <div className="justify-end">
                        <button
                            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                            className="ml-auto p-2 rounded-lg hover:bg-slate-100 transition"
                            aria-label="Collapse sidebar"
                        >
                            {sidebarCollapsed ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
                        </button>
                    </div>
                </div>

                <nav className="flex-1 px-3 py-4 space-y-1 text-sm">
                    {[
                        "Dashboard",
                        "Agenter",
                        "Kunder",
                        "Nummer & telefoni",
                        "Ferdigheter",
                        "Rapporter & økonomi",
                        "CMS & innhold",
                        "Kurs & eventer",
                        "Sosiale medier",
                        "Innstillinger",
                        "Logg out",
                    ].map((item, idx) => {
                        const isActive = (item === tab || (item === "CMS & innhold" && (tab === "CMS" || tab === "Blogs" || tab === "Blog detail")) || (item === "Agenter" && tab === "Agent detail"));

                        // CMS Parent
                        if (item === "CMS & innhold") {
                            return (
                                <div key={item}>
                                    <button
                                        onClick={() => setCmsOpen(prev => !prev)}
                                        className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl transition text-left
                                                    ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}
                                                    `}
                                    >
                                        <span className="inline-flex w-7 h-7 rounded-xl bg-slate-100 items-center justify-center text-[11px] font-semibold text-slate-400">
                                            {idx + 1}
                                        </span>

                                        {!sidebarCollapsed && (
                                            <>
                                                <span className="flex-1 truncate">{item}</span>
                                                {cmsOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                                            </>
                                        )}
                                    </button>

                                    {/* SUB MENU */}
                                    {cmsOpen && !sidebarCollapsed && (
                                        <div className="ml-10 mt-1 space-y-1">
                                            {["CMS", "Blogs"].map(sub => (
                                                <button
                                                    key={sub}
                                                    onClick={() => setTab(sub)}
                                                    className={`w-full text-left px-3 py-2 rounded-lg text-sm transition
                                                                ${(tab === sub || (sub === "Blogs" && tab === "Blog detail"))
                                                                                                        ? "bg-slate-200 text-slate-900 font-medium"
                                                                                                        : "text-slate-500 hover:bg-slate-100"}
                                                            `}
                                                >
                                                    {sub}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        }

                        // Normal items
                        return (
                            <button
                                onClick={() => {
                                    item === "Logg out" ? onLogout() : setTab(item); setCmsOpen(prev => !prev)
                                }}
                                key={item}
                                className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl transition text-left
                                        ${isActive ? "bg-slate-900 text-white shadow-sm" : "text-slate-600 hover:bg-slate-100"}
                                        `}
                            >
                                <span className="inline-flex w-7 h-7 rounded-xl bg-slate-100 items-center justify-center text-[11px] font-semibold text-slate-400">
                                    {idx + 1}
                                </span>

                                {!sidebarCollapsed && (
                                    <span className={`truncate ${item === "Logg out" ? "text-red-600" : ""}`}>
                                        {item}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </nav>

                <div className="px-4 py-4 border-t border-slate-200 text-xs text-slate-500">
                    <p className="font-medium mb-1">Ditt abonnement</p>
                    <p>Pro • 12 rådgivere inkludert</p>
                </div>
            </aside>
        </>
    );
}